import {Moment} from 'moment';
import {List, Set} from 'immutable';

import {OnChanges} from '../../common/common.types';
import {IDischargeDataListCurveController} from '../discharge-data-list-curve.directive';

const addPairDialogTemplate = require<string>('./add-pair-dialog.html');

export interface IDischargeDataItem {
  date?:Moment;
  waterLevel:number;
  discharge:number;
}

export default class DischargeDataListController implements OnChanges {
  static $inject = ['$mdDialog'];

  measuredDischargeDataItems:List<IDischargeDataItem>;
  dischargeDataItems:IDischargeDataItem[];
  selectedDischargeDataItems:IDischargeDataItem[];

  onCreatedItemsChange:(callbackArgs:{
    createdDischargeDataItems:List<IDischargeDataItem>}) => void;
  onSelectedItemsChange:(callbackArgs:{
    selectedDischargeDataItems:List<IDischargeDataItem>}) => void;

  private createdDischargeDataItems:List<IDischargeDataItem>;
  private selectedCreatedDischargeDataItems:Set<IDischargeDataItem>;
  private dischargeDataListCurveController:IDischargeDataListCurveController;

  constructor(private $mdDialog:ng.material.IDialogService) {
    this.dischargeDataItems = [];
    this.selectedDischargeDataItems = [];
    this.createdDischargeDataItems = List<IDischargeDataItem>();
    this.selectedCreatedDischargeDataItems = Set<IDischargeDataItem>();
  }

  $onChanges() {
    this.measuredDischargeDataItems =
        this.measuredDischargeDataItems || List<IDischargeDataItem>();
    this.dischargeDataItems = this.measuredDischargeDataItems
        .concat(this.createdDischargeDataItems)
        .toArray();
    if (this.dischargeDataListCurveController) {
      this.dischargeDataListCurveController
          .onDischargeDataItemsChange(List(this.dischargeDataItems));
    }
    this.selectedDischargeDataItems = [];
    this.notifySelectionChange();
  }

  onDischargeDataItemSelect = (dischargeDataItem:IDischargeDataItem) => {
    if (this.createdDischargeDataItems.contains(dischargeDataItem)) {
      this.selectedCreatedDischargeDataItems =
          this.selectedCreatedDischargeDataItems.add(dischargeDataItem);
    }
    this.notifySelectionChange();
  };

  onDischargeDataItemDeselect = (dischargeDataItem:IDischargeDataItem) => {
    if (this.selectedCreatedDischargeDataItems.contains(dischargeDataItem)) {
      this.selectedCreatedDischargeDataItems =
          this.selectedCreatedDischargeDataItems.remove(dischargeDataItem);
    }
    this.notifySelectionChange();
  };

  get canDelete() {
    return this.selectedCreatedDischargeDataItems.size > 0;
  }

  deleteCreatedDischargePairs() {
    const isNotDeleted = (dischargeDataItem:IDischargeDataItem) =>
        !this.selectedCreatedDischargeDataItems.contains(dischargeDataItem);
    this.selectedDischargeDataItems =
        this.selectedDischargeDataItems.filter(isNotDeleted);
    this.dischargeDataItems = this.dischargeDataItems
        .filter(isNotDeleted);
    this.createdDischargeDataItems = this.createdDischargeDataItems
        .filter(isNotDeleted).toList();
    this.selectedCreatedDischargeDataItems =
        this.selectedCreatedDischargeDataItems.clear();
    this.notifyCreationChange();
    this.notifySelectionChange();
  }

  showCreationDialog($event:MouseEvent) {
    this.$mdDialog.show({
      controller: AddPairDialogController,
      controllerAs: '$ctrl',
      targetEvent: $event,
      template: addPairDialogTemplate
    }).then((pair:{discharge:number, waterLevel:number}) => {
      const newDischargeDataItem:IDischargeDataItem = {
        waterLevel: pair.waterLevel,
        discharge: pair.discharge
      };
      this.createdDischargeDataItems =
          this.createdDischargeDataItems.unshift(newDischargeDataItem);
      this.dischargeDataItems.unshift(newDischargeDataItem);
      this.notifyCreationChange();
    });
  }

  private notifySelectionChange() {
    const selectedDischargeDataItemsList =
        List(this.selectedDischargeDataItems);
    this.onSelectedItemsChange({
      selectedDischargeDataItems: selectedDischargeDataItemsList
    });
    if (this.dischargeDataListCurveController) {
      this.dischargeDataListCurveController
          .onSelectedDischargeDataItemsChange(selectedDischargeDataItemsList);
    }
  }

  private notifyCreationChange() {
    this.onCreatedItemsChange({
      createdDischargeDataItems: this.createdDischargeDataItems
    });
    if (this.dischargeDataListCurveController) {
      this.dischargeDataListCurveController
          .onDischargeDataItemsChange(List(this.dischargeDataItems));
    }
  }
}

class AddPairDialogController {
  static $inject = ['$mdDialog'];

  waterLevel:number;
  discharge:number;

  constructor(private $mdDialog:ng.material.IDialogService) {
  }

  submit() {
    this.$mdDialog.hide({
      waterLevel: this.waterLevel,
      discharge: this.discharge
    });
  }

  dismiss() {
    this.$mdDialog.cancel();
  }
}



/** WEBPACK FOOTER **
 ** ./app/discharge/data-list/discharge-data-list.controller.ts
 **/